import React, { useState, useRef, useEffect } from "react";
import "./ChatGPT.css";
import { streamChatCompletion } from "../../store/services/chatService";
//import { useAuthToken } from "../../hooks/auth";
// src/components/ChatGPT.js

export default function ChatGPT() {
  const authToken = 'test dev'; //useAuthToken();

  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const chatRef = useRef(null);

  // Scroll automatique vers le bas à chaque nouveau message
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  /*
  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");

    // Ajouter un message vide pour l'IA, qui sera rempli en streaming
    setMessages((prev) => [...prev, { role: "assistant", content: "" }]);
    setIsLoading(true);

    let streamed = "";


    try {
      await streamChatCompletion({
        authToken,
        messages: newMessages,
        onToken: (token) => {
          streamed += token;
          setMessages((prev) => {
            const updated = [...prev];
            // On met à jour le dernier message (celui de l'assistant)
            updated[updated.length - 1] = { role: "assistant", content: streamed };
            return updated;
          });
        },
      });
    } catch (error) {
      console.error("Erreur API :", error);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Erreur lors de la génération de la réponse." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };
*/


  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");
    setIsLoading(true);

    try {
      await streamChatCompletion({
        authToken,
        messages: newMessages,
        onToken: (fullAnswer) => {
          // On ajoute le message complet de l'assistant
          setMessages((prev) => [...prev, { role: "assistant", content: fullAnswer }]);
        },
      });
    } catch (error) {
      console.error("Erreur API :", error);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Erreur lors de la génération de la réponse." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="chat-container">
      <div className="chat-title">Inexploré ia — Interface Moderne</div>

      <div className="chat-window" ref={chatRef}>
        {messages.map((msg, i) => (
          <div key={i} className={`message ${msg.role}`}>
            <div className="avatar">{msg.role === "user" ? "U" : "ia"}</div>
            <div className="bubble">{msg.content}</div>
          </div>
        ))}

        {isLoading && (
          <div className="message assistant typing">
            <div className="avatar">ia</div>
            <div className="bubble typing">L'IA écrit…</div>
          </div>
        )}
      </div>

      <div className="input-area">
        <input
          placeholder="Envoyer un message…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage} disabled={isLoading}>
          Envoyer
        </button>
      </div>
    </div>
  );
}
